module.exports = __webpack_public_path__ + "t-rowe-mockup.wRlUM_rS.png";